var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchivedOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.414 3C6.88361 3.00011 6.37499 3.2109 6 3.586L3.586 6C3.31199 6.27373 3.12336 6.62112 3.043 7H20.957C20.8766 6.62112 20.688 6.27373 20.414 6L18 3.586C17.625 3.2109 17.1164 3.00011 16.586 3H7.414ZM21 9H3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V9ZM12 11C12.2652 11 12.5196 11.1054 12.7071 11.2929C12.8946 11.4804 13 11.7348 13 12V15.186L13.414 14.771C13.6016 14.5835 13.8561 14.4782 14.1214 14.4783C14.3866 14.4784 14.641 14.5839 14.8285 14.7715C15.016 14.9591 15.1213 15.2136 15.1212 15.4789C15.1211 15.7441 15.0156 15.9985 14.828 16.186L12.708 18.307C12.6151 18.4 12.5048 18.4737 12.3834 18.5241C12.262 18.5744 12.1319 18.6003 12.0005 18.6003C11.8691 18.6003 11.739 18.5744 11.6176 18.5241C11.4962 18.4737 11.3859 18.4 11.293 18.307L9.172 16.186C8.98436 15.9985 8.87889 15.7441 8.8788 15.4789C8.8787 15.2136 8.98399 14.9591 9.1715 14.7715C9.35901 14.5839 9.61338 14.4784 9.87865 14.4783C10.1439 14.4782 10.3984 14.5835 10.586 14.771L11 15.186V12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedOrders);
export default __webpack_public_path__ + "static/media/archived-orders.c262d8e4ffe8c124bde94d2c80ef08c7.svg";
export { ForwardRef as ReactComponent };